<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-right d-flex flex-wrap align-items-center justify-content-between">
      <p class="mb-0 f-w-600">Shining On Safety - construction safety solutions <br> Confidential and proprietary
        Copyright ©️ Shining on Safety. All Rights Reserved </p>
      <p class="mb-0 f-w-600">About us -
        <i class="fa fa-facebook-square fa-2x me-2" id="icon_main"></i>
        <i class="fa fa-instagram fa-2x me-2" id="icon_main"></i>
        <i class="fa fa-twitter-square fa-2x" id="icon_main"></i>
      </p>
    </div>
  </div>
</div>